//
// 评论模块基础脚本
// --------------------------------------------------

$(document).ready(function() {

    // 评论模块基础脚本
    $(".form-comment-wrapper .form-input").on("focusin", function() {
        $(this).parents(".form-comment-wrapper").addClass("form-comment-wrapper-active");
    });

    $(".form-comment-wrapper .form-input").on("focusout", function() {
        $(this).parents(".form-comment-wrapper").removeClass("form-comment-wrapper-active");
    });

    $(".j_comment_reply").on("click", function() {
        // 删除其它的评论模块
        $(".comment-wrapper .comment-reply-wrapper").remove();
        // 定位当前评论层位置
        var $targetElement = $(this).parent(".comment-attach");
        // 克隆模板到当前评论层
        $targetElement.after($("#j_comment_reply_template").clone(true));
        // 删除克隆模板 id , 移除隐藏 class , 子元素form添加 id ,输入框 修改 placeholder
        $targetElement
            .next(".comment-reply-template")
            .removeAttr("id").removeClass("comment-reply-template hidden").addClass("comment-reply-wrapper")
            .children(".comment-form-reply")
            .attr("id", "j_form_reply")
            .find(".form-input")
            .attr("placeholder", "回复 " + $targetElement.prev(".comment-container").children(".comment-author:first-child").text())
            .attr("id", "j_comment_replay_input")
            .end()
            .find('.emotion-wrapper')
            .attr("id", "j_comment_replay_emotion");

        // 表情
        $('#j_comment_replay_emotion').socialEmotion({
            id: 'j_comment_replay_emotion_inner',
            assign: 'j_comment_replay_input',
            path: 'img/emotion/'
        });
    });

    // 取消评论
    $(".reply-cancel").on("click", function() {
        $(this).parents(".comment-reply-wrapper").remove();
    });

    // 表情
    $('#j_comment_post_emotion').socialEmotion({
        id: 'j_comment_post_emotion_inner',
        assign: 'j_comment_post_input',
        path: 'img/emotion/'
    });

    // comment post captcha
    // captcha demo:hs-captcha.js
    var captchaDemo = new hs.Captcha({
        captchaForm: "#j_comment_post_captcha"
    });
    captchaDemo.init();

});